export default __webpack_public_path__ + "static/media/ES_flag.cae6f903.svg";